/*
 * Quiz Etnalia — state machine
 *
 *   ┌──────┐   ┌──────────┐(N=cfg)┌────────┐    ┌──────┐     ┌─────────┐ 4.2s  ┌───────┐
 *   │ hero │──▶│ question │──────▶│ social │──▶ │ name │ ──▶ │ loading │ ────▶ │ carta │
 *   └──────┘   └────┬─────┘       │ proof  │    └──────┘     │ 3-bars  │       └───┬───┘
 *                   ▲ │           └────────┘                 └─────────┘           │
 *                   │ ▼  (after socialProofAfter id, e.g. q3)                       │ inline
 *               next question                                                       ▼ builder
 *                                                                              applyHandles
 *
 * Back button: pops history stack — restores previous screen + state.
 * Fail mode: invalid config / fetch error / runtime exception → window.location = builder_url.
 * No localStorage. Refresh = restart. No backend.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-quiz]');
  if (!root) return;

  var BUILDER_URL = root.getAttribute('data-builder-url') || '/pages/difusor-etnalia-suscripcion';
  var CONFIG_URL = root.getAttribute('data-config-url');
  var TRANSITION_MS = 280;
  // Loading sequence — 3 sequential bars
  var LOAD_DURATIONS = [1200, 1500, 1500]; // ms per track
  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (REDUCED_MOTION) {
    TRANSITION_MS = 0;
    LOAD_DURATIONS = [400, 400, 400];
  }

  document.body.classList.add('template-quiz-etnalia');

  var state = {
    screen: 'hero',
    questionIdx: 0,
    answers: [],
    name: '',
    winners: [],
    // history: stack of snapshots for the back button
    history: []
  };

  var config = null;
  var socialProofShown = false; // shown at most once per session

  // Cached nodes
  var screens = {};
  root.querySelectorAll('[data-screen]').forEach(function (el) {
    screens[el.getAttribute('data-screen')] = el;
  });
  var questionMount = root.querySelector('[data-quiz-question-mount]');
  var questionDeco = root.querySelector('[data-quiz-question-deco]');
  var progressBar = root.querySelector('[data-quiz-progress-bar]');
  var nameForm = root.querySelector('[data-quiz-name-form]');
  var nameInput = root.querySelector('[data-quiz-name-input]');
  var nameSpans = root.querySelectorAll('[data-quiz-name]');
  var mezclaCards = root.querySelectorAll('[data-mezcla-card]');
  var startBtn = root.querySelector('[data-quiz-start]');
  var socialContinueBtn = root.querySelector('[data-quiz-social-continue]');
  var backBtn = root.querySelector('[data-quiz-back]');
  var counterEl = root.querySelector('[data-quiz-counter]');
  var loadingTracks = root.querySelectorAll('[data-quiz-track]');

  // Map handle → image URL, sourced from the inline pack-etnalia-builder JSON.
  // Gives us the clean Step-1 PNGs without duplicating image config.
  var imagesByHandle = {};
  (function readBuilderImages() {
    var dataEl = document.querySelector('.pack-builder [data-pack-data]');
    if (!dataEl) return;
    try {
      var d = JSON.parse(dataEl.textContent);
      if (d && Array.isArray(d.blends)) {
        d.blends.forEach(function (b) {
          if (b && b.handle && b.imageUrl) imagesByHandle[b.handle] = b.imageUrl;
        });
      }
    } catch (e) { /* fallback img in Liquid stays */ }
  })();

  mezclaCards.forEach(function (card) {
    var handle = card.getAttribute('data-handle');
    var img = card.querySelector('[data-mezcla-image]');
    if (img && imagesByHandle[handle]) img.setAttribute('src', imagesByHandle[handle]);
  });

  // ─────────────────────────────────────────────────────────────
  // Helpers
  // ─────────────────────────────────────────────────────────────
  function bailToBuilder(reason) {
    if (reason) console.error('[quiz-etnalia]', reason);
    window.location.href = BUILDER_URL;
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function validateConfig(c) {
    if (!c || typeof c !== 'object') return 'config not an object';
    if (!Array.isArray(c.mezclas) || c.mezclas.length === 0) return 'mezclas allowlist missing';
    if (!Array.isArray(c.questions) || c.questions.length === 0) return 'no questions';
    for (var i = 0; i < c.questions.length; i++) {
      var q = c.questions[i];
      if (!q.id || !q.question) return 'question ' + i + ' missing id/question';
      if (!Array.isArray(q.answers) || q.answers.length < 2) return 'question ' + q.id + ' needs ≥2 answers';
      for (var j = 0; j < q.answers.length; j++) {
        var a = q.answers[j];
        if (!a.label) return 'q ' + q.id + ' answer ' + j + ' missing label';
        if (!a.scores || typeof a.scores !== 'object') return 'q ' + q.id + ' answer ' + j + ' missing scores';
        var keys = Object.keys(a.scores);
        if (keys.length === 0) return 'q ' + q.id + ' answer ' + j + ' has empty scores';
        for (var k = 0; k < keys.length; k++) {
          if (c.mezclas.indexOf(keys[k]) === -1) return 'q ' + q.id + ' answer ' + j + ' references unknown handle ' + keys[k];
        }
      }
    }
    return null;
  }

  function computeWinners() {
    var scores = {};
    config.mezclas.forEach(function (h) { scores[h] = 0; });
    state.answers.forEach(function (a) {
      var q = config.questions.find(function (qq) { return qq.id === a.questionId; });
      if (!q) return;
      var ans = q.answers[a.answerIdx];
      if (!ans || !ans.scores) return;
      Object.keys(ans.scores).forEach(function (handle) {
        if (scores.hasOwnProperty(handle)) scores[handle] += ans.scores[handle];
      });
    });
    var tbQ = config.questions.find(function (qq) { return qq.id === config.tieBreakerQuestion; });
    var tbAnswer = state.answers.find(function (an) { return an.questionId === config.tieBreakerQuestion; });
    var tbScores = (tbQ && tbAnswer && tbQ.answers[tbAnswer.answerIdx]) ? tbQ.answers[tbAnswer.answerIdx].scores : {};
    var sorted = config.mezclas.slice().sort(function (a, b) {
      if (scores[b] !== scores[a]) return scores[b] - scores[a];
      return (tbScores[b] || 0) - (tbScores[a] || 0);
    });
    return sorted.slice(0, 3);
  }

  // ─────────────────────────────────────────────────────────────
  // Header chrome (back button + counter) — visibility per screen
  // ─────────────────────────────────────────────────────────────
  function updateHeader() {
    var s = state.screen;
    // Back visible on every screen EXCEPT hero, loading and carta.
    var showBack = (s === 'question' || s === 'name' || s === 'social');
    if (backBtn) backBtn.style.visibility = showBack ? 'visible' : 'hidden';

    // Counter: only during question / social proof
    if (counterEl) {
      if (s === 'question' && config) {
        counterEl.textContent = 'Pregunta ' + (state.questionIdx + 1) + ' de ' + config.questions.length;
      } else if (s === 'social') {
        counterEl.textContent = '';
      } else {
        counterEl.textContent = '';
      }
    }
  }

  // ─────────────────────────────────────────────────────────────
  // Screen transitions
  // ─────────────────────────────────────────────────────────────
  function showScreen(name) {
    var current = screens[state.screen];
    var next = screens[name];
    if (!next) return;
    if (current && current !== next) {
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      setTimeout(function () {
        current.setAttribute('hidden', '');
        current.classList.remove('is-leaving');
      }, TRANSITION_MS);
    }
    next.removeAttribute('hidden');
    void next.offsetWidth;
    next.classList.add('is-active');
    state.screen = name;
    updateHeader();
    if (REDUCED_MOTION) {
      root.scrollIntoView({ block: 'start' });
    } else {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // ─────────────────────────────────────────────────────────────
  // History — push a snapshot before each forward move
  // ─────────────────────────────────────────────────────────────
  function pushHistory() {
    state.history.push({
      screen: state.screen,
      questionIdx: state.questionIdx,
      answersLen: state.answers.length,
      socialProofShown: socialProofShown
    });
  }

  function goBack() {
    var prev = state.history.pop();
    if (!prev) return;
    // Roll back answers if we popped past a recorded answer
    if (state.answers.length > prev.answersLen) {
      state.answers.length = prev.answersLen;
    }
    socialProofShown = prev.socialProofShown;
    state.questionIdx = prev.questionIdx;
    if (prev.screen === 'question') {
      showScreen('question');
      renderQuestion(state.questionIdx);
    } else if (prev.screen === 'social') {
      showScreen('social');
    } else if (prev.screen === 'hero') {
      showScreen('hero');
    } else if (prev.screen === 'name') {
      // shouldn't happen but just in case
      showScreen('name');
    }
  }

  // ─────────────────────────────────────────────────────────────
  // Render question screen — content driven by config JSON
  // ─────────────────────────────────────────────────────────────
  function renderQuestion(idx) {
    var q = config.questions[idx];
    if (!q) return goToName();

    var total = config.questions.length;
    var html = '';
    if (q.eyebrow) html += '<span class="quiz__eyebrow">' + escapeHtml(q.eyebrow) + '</span>';
    html += '<h2 class="quiz__question-title title h2">' + escapeHtml(q.question) + '</h2>';
    html += '<span class="visually-hidden">Pregunta ' + (idx + 1) + ' de ' + total + '</span>';
    html += '<div class="quiz__answers" role="group" aria-label="Respuestas">';
    q.answers.forEach(function (a, j) {
      html += '<button type="button" class="quiz__answer" data-quiz-answer="' + j + '">';
      if (a.emoji) {
        html += '<span class="quiz__answer-emoji" aria-hidden="true">' + escapeHtml(a.emoji) + '</span>';
      }
      html += '<span class="quiz__answer-text">' + escapeHtml(a.label) + '</span>';
      html += '</button>';
    });
    html += '</div>';

    questionMount.innerHTML = html;

    if (questionDeco && q.decoration) {
      var assetBase = CONFIG_URL.replace(/[^/]*$/, '');
      questionDeco.setAttribute('src', assetBase + q.decoration);
    }

    if (progressBar) {
      var pct = Math.round(((idx + 1) / total) * 100);
      progressBar.style.width = pct + '%';
    }

    questionMount.querySelectorAll('[data-quiz-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        onAnswer(parseInt(btn.getAttribute('data-quiz-answer'), 10));
      });
    });

    var first = questionMount.querySelector('[data-quiz-answer]');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, TRANSITION_MS);

    updateHeader();
  }

  // ─────────────────────────────────────────────────────────────
  // Flow advancement
  // ─────────────────────────────────────────────────────────────
  function onAnswer(answerIdx) {
    var q = config.questions[state.questionIdx];
    pushHistory();
    state.answers.push({ questionId: q.id, answerIdx: answerIdx });

    // Should we insert the social proof screen after this question?
    if (!socialProofShown && config._socialProofAfter && q.id === config._socialProofAfter && hasAnySocialImage()) {
      socialProofShown = true;
      showScreen('social');
      // We'll bump questionIdx when the social CTA is clicked.
      return;
    }

    state.questionIdx += 1;
    if (state.questionIdx >= config.questions.length) {
      goToName();
    } else {
      renderQuestion(state.questionIdx);
    }
  }

  function hasAnySocialImage() {
    var imgs = root.querySelectorAll('.quiz__social-cell img');
    return imgs.length > 0;
  }

  function onSocialContinue() {
    pushHistory();
    state.questionIdx += 1;
    if (state.questionIdx >= config.questions.length) {
      goToName();
    } else {
      showScreen('question');
      renderQuestion(state.questionIdx);
    }
  }

  function goToName() {
    showScreen('name');
    setTimeout(function () { if (nameInput) nameInput.focus({ preventScroll: true }); }, TRANSITION_MS);
  }

  // ─────────────────────────────────────────────────────────────
  // Loading — 3 sequential bars (≈4.2s)
  // ─────────────────────────────────────────────────────────────
  function runLoadingSequence() {
    // Reset all tracks to 0
    loadingTracks.forEach(function (t) {
      var fill = t.querySelector('.quiz__loading-fill');
      var pct = t.querySelector('.quiz__loading-pct');
      if (fill) { fill.style.transition = 'none'; fill.style.width = '0%'; }
      if (pct) pct.textContent = '0%';
      t.classList.remove('is-active', 'is-done');
    });
    // Force reflow before re-enabling transitions
    void root.offsetWidth;

    var idx = 0;
    function fillNext() {
      if (idx >= loadingTracks.length) {
        // All done — reveal carta after a beat
        setTimeout(revealCarta, REDUCED_MOTION ? 0 : 200);
        return;
      }
      var track = loadingTracks[idx];
      var fill = track.querySelector('.quiz__loading-fill');
      var pct = track.querySelector('.quiz__loading-pct');
      var dur = LOAD_DURATIONS[idx] || 1200;
      track.classList.add('is-active');
      if (fill) {
        fill.style.transition = 'width ' + dur + 'ms ease-out';
        // Force reflow then set width to 100%
        void fill.offsetWidth;
        fill.style.width = '100%';
      }
      // Animate percentage label
      animatePercent(pct, 0, 100, dur);
      setTimeout(function () {
        track.classList.add('is-done');
        track.classList.remove('is-active');
        idx += 1;
        fillNext();
      }, dur);
    }
    fillNext();
  }

  function animatePercent(el, from, to, duration) {
    if (!el) return;
    var startedAt = performance.now();
    function step(now) {
      var t = Math.min(1, (now - startedAt) / duration);
      var val = Math.round(from + (to - from) * t);
      el.textContent = val + '%';
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  // ─────────────────────────────────────────────────────────────
  // Name submit → preload winners → loading → carta
  // ─────────────────────────────────────────────────────────────
  function onNameSubmit(e) {
    e.preventDefault();
    var raw = (nameInput.value || '').trim();
    if (!raw) return nameInput.focus();
    var clean = raw.replace(/<[^>]*>/g, '').slice(0, 40);
    if (!clean) return nameInput.focus();

    state.name = clean;
    state.winners = computeWinners();
    nameSpans.forEach(function (s) { s.textContent = clean; });

    // Preload winner images
    state.winners.forEach(function (handle) {
      var card = root.querySelector('[data-mezcla-card][data-handle="' + handle + '"]');
      var img = card && card.querySelector('[data-mezcla-image]');
      var src = img && img.getAttribute('src');
      if (src) {
        var link = document.createElement('link');
        link.rel = 'preload'; link.as = 'image'; link.href = src;
        document.head.appendChild(link);
      }
    });

    showScreen('loading');
    runLoadingSequence();
  }

  function revealCarta() {
    mezclaCards.forEach(function (card) {
      var handle = card.getAttribute('data-handle');
      if (state.winners.indexOf(handle) !== -1) card.removeAttribute('hidden');
      else card.setAttribute('hidden', '');
    });

    var builderRoot = document.querySelector('.pack-builder[data-section-id]');
    if (builderRoot && typeof builderRoot.__packBuilderApplyHandles === 'function') {
      try { builderRoot.__packBuilderApplyHandles(state.winners); } catch (e) { console.warn('[quiz-etnalia] builder API error', e); }
    }

    document.body.classList.add('has-quiz-result');
    showScreen('carta');
  }

  // ─────────────────────────────────────────────────────────────
  // Start
  // ─────────────────────────────────────────────────────────────
  function start() {
    state.questionIdx = 0;
    state.answers = [];
    state.history = [];
    socialProofShown = false;
    pushHistory(); // hero snapshot so back from q1 returns to hero
    showScreen('question');
    renderQuestion(0);
  }

  // ─────────────────────────────────────────────────────────────
  // Boot
  // ─────────────────────────────────────────────────────────────
  function boot() {
    if (!CONFIG_URL) return bailToBuilder('no config url');

    if (startBtn) startBtn.addEventListener('click', function (e) { e.preventDefault(); start(); });
    if (nameForm) nameForm.addEventListener('submit', onNameSubmit);
    if (socialContinueBtn) socialContinueBtn.addEventListener('click', onSocialContinue);
    if (backBtn) backBtn.addEventListener('click', goBack);

    updateHeader();

    fetch(CONFIG_URL, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('config fetch HTTP ' + r.status); return r.json(); })
      .then(function (c) {
        var err = validateConfig(c);
        if (err) throw new Error('config invalid: ' + err);
        config = c;
      })
      .catch(function (e) { bailToBuilder(e.message || e); });
  }

  window.addEventListener('error', function (e) {
    if (e && e.filename && e.filename.indexOf('quiz-etnalia') !== -1) {
      bailToBuilder('runtime error: ' + (e.message || ''));
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
